﻿import { ContactEntityType } from '../enums/index';
import { IContactOverridePrimaryAddressRequest } from './contact-override-primary-address-request';
import { IPhoneNumberRequest } from './phone-number-request';
import { IEmailFlagValue } from './email-flag-value';

export interface IContactRequest {
    id: number,
    organType: number,
    isDeleted: boolean,
    entityType: ContactEntityType,
    entityTypeId: number,
    positions: number[],
    title: string,
    prefix: string,
    firstName: string,
    middleName: string,
    lastName: string,
    nameSuffix: string,
    email: string,
    secondaryEmail: string,
    emailSignature?: string,
    addressId1: number,
    address1Suite: string,
    address1Override: IContactOverridePrimaryAddressRequest,
    addressId2: number,
    address2Suite: string,
    address2Override: string,
    galaEmailOverride: string,
    conferenceNumber: string,
    conferenceNumberCode: string,
    conferenceNumberMobileFriendly: string,
    phoneNumbers: IPhoneNumberRequest[],
    emailFlags: IEmailFlagValue[],
    tags: string[],
}
